import { TimeSignalAnalytic, TimeSignalDimensionType } from 'graphql/types';
export const bubbleColorSet = {
  PROJECT: '#0bb8df',
  CLIENT: '#f1a057',
  TASK: '#26d293',
  SELECT: '#8a06ee',
  ACTIVITY: '#c258d4',
  BILLING: '#2fc9cb'
} as Record<string, string>;

type transformAnalyticsDatatoBubbleProps = {
  dataSet: {
    label: string;
    id: string;
    color: string;
    value: number;
    type: string;
  }[];

  legendSet: string[];
};

type dataSetProp = {
  label: string;
  id: string;
  color: string;
  value: number;
  type: string;
};

export function transformAnalyticsDatatoBubble(
  data: TimeSignalAnalytic | undefined
): transformAnalyticsDatatoBubbleProps {
  const legendSet = new Set<string>();
  if (!data) {
    return { dataSet: [], legendSet: [] };
  }
  const dataSet = data.dimensions.reduce((acc, _data, index) => {
    if (
      (_data?.metadata || []).length > 0 &&
      _data.dimensionType === TimeSignalDimensionType.MetricsByKeywords
    ) {
      let labelId;
      let type = '';
      _data?.metadata?.forEach((e) => {
        if (e?.key === 'type') {
          type = e.value as string;
        } else {
          labelId = e?.value as string;
        }
      });
      const color = bubbleColorSet[type];
      const result = {
        label: _data.name,
        id: _data.id || '',
        color: color,
        value: data.metrics[index].totalCount,
        type: type,
        labelId: labelId
      };
      acc.push(result);
      return acc;
    } else {
      return acc;
    }
  }, [] as dataSetProp[]);
  dataSet.sort((a, b) => b.value - a.value);
  let top25DataSet;
  if (dataSet.length > 25) {
    top25DataSet = dataSet.slice(0, 25);
  } else {
    top25DataSet = dataSet;
  }
  top25DataSet.forEach((i) => {
    legendSet.add(i.type);
  });
  return { dataSet: top25DataSet, legendSet: Array.from(legendSet) };
}
